import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAllSubContractor() {
    try {
        const response = await apiGet('core', `sub_contractor`);
        return response.content;
    } catch (e) { }
}

export async function getSubContractor(id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiGet('core', `sub_contractor/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addSubContractor(newDetails: any) {
    try {
        const response = await apiPost('core', `sub_contractor`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateSubContractor(newDetails: any, id?: string) {
    try {
        const response = await apiPut('core', `sub_contractor/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeSubContractor(id: any) {
    try {

        return await apiDelete('core', `sub_contractor/${id}`);
    } catch (e) { }
}

export async function siteSubContractorAdd(body: any) {
    try {
        const response = await apiPost('core', `site-sub-contractor`, body);
        return response;
    } catch (e) { }
}

export async function siteSubContractorUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-sub-contractor/${id}`, body);
        return response;
    } catch (e) { }
}
